import {
  VerificationNames,
  DataVendors,
  CreditReportModels,
  AnimalScreeningReportVendors
} from "shared/types";
import logo from "shared/branding/logo.svg";

export const getLogoSrc = (
  name:
    | VerificationNames
    | DataVendors
    | CreditReportModels
    | AnimalScreeningReportVendors
) => {
  switch (name) {
    case VerificationNames.HousingHistory:
      return logo;
    case VerificationNames.IdentityVerification:
      return "/assets/plaid_logo.svg";
    case VerificationNames.CreditReport:
      return "/assets/equifax_logo.svg";
    case DataVendors.CIC:
      return "/assets/cic_logo.svg";
    case DataVendors.Cleara:
      return "/assets/cleara_logo.svg";
    case DataVendors.Certn:
      return "/assets/certn_logo.svg";
    case DataVendors.Persona:
      return "/assets/persona_logo.svg";
    case DataVendors.Plaid:
      return "/assets/plaid_logo.svg";
    case DataVendors.TransUnion:
      return "/assets/transunion_logo.svg";
    case DataVendors.Equifax:
      return "/assets/equifax_logo.svg";
    case CreditReportModels.VantageScore:
      return "/assets/vantage_credit_model.svg";
    case CreditReportModels.FicoScore:
      return "/assets/fico_credit_model.svg";
    case AnimalScreeningReportVendors.PetScreening:
      return "/assets/pet_screening_logo.svg";
    case AnimalScreeningReportVendors.OurPetPolicy:
      return "/assets/our_pet_policy_logo.svg";
    default:
      return;
  }
};
